export const extra_charge = {
  0: {
    name: "Costi di servizio",
    tooltip: ""
  },
  1: {
    name: "Costi di servizio",
    tooltip: ""
  },
  2: {
    name: "Supplemento obbligatorio servizi extra",
    tooltip: ""
  },
  3: {
    name: "Costo pulizia",
    tooltip: ""
  },
  4: {
    name: "Costo asciugamani",
    tooltip: ""
  },
  5: {
    name: "Costo elettricità",
    tooltip: ""
  },
  6: {
    name: "Costo lenzuola",
    tooltip: ""
  },
  7: {
    name: "Costo gas",
    tooltip: ""
  },
  8: {
    name: "Costo benzina",
    tooltip: ""
  },
  9: {
    name: "Costo legna",
    tooltip: ""
  },
  10: {
    name: "Costo acqua",
    tooltip: ""
  },
  11: {
    name: "Tassa locale",
    tooltip: ""
  },
  12: {
    name: "Ecotassa",
    tooltip: ""
  },
  13: {
    name: "Tassa centro benessere",
    tooltip: ""
  },
  14: {
    name: "Costi di trasferimento",
    tooltip: ""
  },
  15: {
    name: "Costo di assicurazione",
    tooltip: ""
  },
  21: {
    name: "IVA",
    tooltip: ""
  },
  22: {
    name: "Tassa di soggiorno",
    tooltip: "La tassa di soggiorno viene definita dall'Amministrazione Comunale, è quindi soggetta a variazioni oppure l'hotel potrebbe avere inserito dati non corretti. Se desideri informazioni definitive consulta il sito del Comune o contatta la struttura alberghiera."
  },
  23: {
    name: "Tassa",
    tooltip: ""
  },
  31: {
    name: "Sconto",
    tooltip: ""
  },
  100: {
    name: "Costo set di biancheria",
    tooltip: ""
  },
  101: {
    name: "Costo riscaldamento",
    tooltip: ""
  },
  102: {
    name: "Costo aria condizionata",
    tooltip: ""
  },
  103: {
    name: "Costo biancheria da cucina",
    tooltip: ""
  },
  104: {
    name: "Costo servizio di pulizia",
    tooltip: ""
  },
  105: {
    name: "Costo navetta aeroportuale",
    tooltip: ""
  },
  106: {
    name: "Costo traghetto",
    tooltip: ""
  },
  107: {
    name: "Costo cena di gala",
    tooltip: ""
  },
  108: {
    name: "Costo idrovolante",
    tooltip: ""
  },
  109: {
    name: "Ski pass",
    tooltip: ""
  },
  110: {
    name: "Costo pulizia finale",
    tooltip: ""
  },
  111: {
    name: "Costo braccialetto",
    tooltip: ""
  },
  112: {
    name: "Costo agevolazione visto",
    tooltip: ""
  },
  113: {
    name: "Costo parco acquatico",
    tooltip: ""
  },
  114: {
    name: "Costo carta fedeltà",
    tooltip: ""
  },
  115: {
    name: "Tassa tutela ambientale",
    tooltip: ""
  },
  116: {
    name: "Costo di transazione per pagamenti con carta di credito",
    tooltip: ""
  },
  117: {
    name: "Supplemento animali domestici",
    tooltip: ""
  },
  118: {
    name: "Costo internet",
    tooltip: ""
  },
  119: {
    name: "Costo parcheggio",
    tooltip: ""
  },
  120: {
    name: "Supplemento locale",
    tooltip: ""
  },
  140: {
    name: "Tassa sorgenti termali",
    tooltip: ""
  },
  141: {
    name: "Tassa municipale",
    tooltip: ""
  },
  142: {
    name: "Imposta di soggiorno",
    tooltip: ""
  },
  143: {
    name: "Tassa residenziale",
    tooltip: ""
  },
  144: {
    name: "Biglietto giornaliero mezzi pubblici",
    tooltip: ""
  },
  145: {
    name: "Tassa beni e servizi",
    tooltip: ""
  },
  146: {
    name: "Tassa patrimonio culturale",
    tooltip: ""
  },
  147: {
    name: "Tassa sauna/centro fitness",
    tooltip: ""
  },
  148: {
    name: "Tasse governative",
    tooltip: ""
  },
  149: {
    name: "Tasse comunali",
    tooltip: ""
  },
  150: {
    name: "Tassa del Kerala per ricostruzione dopo inondazione",
    tooltip: ""
  },
  151: {
    name: "Costo di sostenibilità",
    tooltip: ""
  },
  152: {
    name: "Tassa governativa",
    tooltip: ""
  },
  153: {
    name: "Tassa di tutela ambientale",
    tooltip: ""
  },
  154: {
    name: "Tassa locale",
    tooltip: ""
  },
  180: {
    name: "Spa",
    tooltip: ""
  },
  181: {
    name: "Sauna",
    tooltip: ""
  },
  182: {
    name: "Vasca idromassaggio",
    tooltip: ""
  },
  183: {
    name: "Centro fitness",
    tooltip: ""
  },
  184: {
    name: "Noleggio biciclette",
    tooltip: ""
  },
  185: {
    name: "Servizio massaggi",
    tooltip: ""
  },
  186: {
    name: "Campo da tennis",
    tooltip: ""
  },
  187: {
    name: "Lavanderia",
    tooltip: ""
  },
  188: {
    name: "Servizio di presa e consegna auto",
    tooltip: ""
  },
  189: {
    name: "Giardino d'inverno",
    tooltip: ""
  },
  190: {
    name: "Bagno turco/di vapore",
    tooltip: ""
  },
  191: {
    name: "Chef privato",
    tooltip: ""
  },
  192: {
    name: "Vasca termale",
    tooltip: ""
  },
  193: {
    name: "Cassaforte/armadietto",
    tooltip: ""
  },
  194: {
    name: "Escursione",
    tooltip: ""
  },
  195: {
    name: "Attrezzatura per barbecue",
    tooltip: ""
  },
  196: {
    name: "Stiratura",
    tooltip: ""
  },
  197: {
    name: "Ombrellone",
    tooltip: ""
  },
  198: {
    name: "Parco acquatico",
    tooltip: ""
  },
  199: {
    name: "Campo da golf",
    tooltip: ""
  },
  200: {
    name: "Lettino",
    tooltip: ""
  },
  201: {
    name: "Escursionismo",
    tooltip: ""
  },
  202: {
    name: "Salone di bellezza",
    tooltip: ""
  },
  203: {
    name: "Immersioni",
    tooltip: ""
  },
  204: {
    name: "Piscina",
    tooltip: ""
  },
  205: {
    name: "Spiaggia privata",
    tooltip: ""
  },
  206: {
    name: "Seggiolone",
    tooltip: ""
  },
  207: {
    name: "Autonoleggio",
    tooltip: ""
  },
  208: {
    name: "Servizio di babysitter",
    tooltip: ""
  },
  209: {
    name: "Club benessere",
    tooltip: ""
  },
  210: {
    name: "Hammam",
    tooltip: ""
  },
  211: {
    name: "Lounge",
    tooltip: ""
  },
  240: {
    name: "Offerta esclusiva",
    tooltip: ""
  }
}

export function get_extra_charge(key) {
  const charge = extra_charge[key]
  if (charge !== undefined) {
    return {
      name: charge.name,
      tooltip: charge.tooltip,
    }
  }
  return {
    name: key,
    tooltip: ""
  }
}